import { FormField, Incident, initialBasicInfoType } from '../types/types';

export const ProductType = 'RPDPLACEHOLDER';

export enum ProductPermissions {
  PLACEHOLDER = 'PLACEHOLDER',
}

export const RESOLUTION_INFO_INDEX = 1;
export const ACTIVITY = 2;
export const PAGESIZE = 20;
export const STORE_NUMBER_KEY = 'storeNumber';

export const CSM_SUCCESS_MESSAGE =
  'Your incident has been created successfully';
export const CSM_SUCCESS_MESSAGE_2 = 'Ticket number:';
export const CSM_REQUEST_ERROR_MESSAGE = 'Incident creation failed!';
export const CSM_REQUEST_ERROR_MESSAGE_2 =
  'There was an error processing your request. Please try again later';
export const CSM_SUCCESS_MESSAGE_3 =
  'Your incident has been updated successfully';

export const requiredFields: (keyof Incident['basicInfo'])[] = [
  'channel',
  'request_type',
  'category',
  'firstName',
  'sub_category',
  'lastName',
  'action_type',
  'callback',
  'storenumber',
  'shortDescription',
  'description',
  'language',
];

export const fields: { name: FormField; label: string; disabled?: boolean }[] =
  [
    { name: 'ticketNumber', label: 'Incident Number', disabled: true },
    { name: 'channel', label: 'Channel' },
    { name: 'request_type', label: 'Requestor Type' },
    { name: 'category', label: 'Category' },
    { name: 'firstName', label: 'First Name' },
    { name: 'sub_category', label: 'Subcategory' },
    { name: 'lastName', label: 'Last Name' },
    { name: 'action_type', label: 'Action' },
    { name: 'callback', label: 'Call-Back Number' },
    { name: 'agreementnumber', label: 'Rental Agreement Number' },
    { name: 'alterphonenumb', label: 'Alternate Phone Number' },
    { name: 'storenumber', label: 'Store Number' },
    { name: 'shortDescription', label: 'Short Description' },
    { name: 'language', label: 'Language' },
    { name: 'description', label: 'Description' },
  ];

export const editfields: {
  name: FormField;
  label: string;
  disabled?: boolean;
}[] = [
  { name: 'ticketNumber', label: 'Number', disabled: true },
  { name: 'firstName', label: 'First Name' },
  { name: 'lastName', label: 'Last Name' },
  { name: 'request_type', label: 'Requestor Type' },
  { name: 'callback', label: 'Call Back Number' },
  { name: 'alterphonenumb', label: 'Alternate Phone Number' },
  { name: 'channel', label: 'Channel' },
  { name: 'category', label: 'Category' },
  { name: 'sub_category', label: 'Subcategory' },
  { name: 'action_type', label: 'Action' },
  { name: 'agreementnumber', label: 'Rental Agreement Number' },
  { name: 'storenumber', label: 'Store Number' },
  { name: 'language', label: 'Language' },
  { name: 'shortDescription', label: 'Short Description' },
  { name: 'description', label: 'Description' },
];

export const initialBasicInfo: initialBasicInfoType = {
  ticketNumber: '',
  channel: '',
  request_type: '',
  category: '',
  firstName: '',
  sub_category: '',
  lastName: '',
  action_type: '',
  callback: '',
  agreementnumber: '',
  alterphonenumb: '',
  storenumber: '',
  shortDescription: '',
  description: '',
  language: '',
  attachments: [],
  assignment: {
    assignmentGroup: '',
    esName: '',
    escalationContact: '',
    role: '',
    escalatedTo: '',
  },
};
